export default __webpack_public_path__ + "static/media/pebImg.50a56e9b.png";